var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5C22 12.5968 21.0439 14.3587 19.75 14.8582V18.25H22C22.4142 18.25 22.75 18.5858 22.75 19C22.75 19.4142 22.4142 19.75 22 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H3.95V12.5H2.75841C2.08409 12.5 1.74639 11.7696 2.2232 11.3424L7.9648 6.19861C8.26038 5.9338 8.73962 5.9338 9.0352 6.19861L14.7768 11.3424C15.2536 11.7696 14.9159 12.5 14.2416 12.5H13.05V18.25H18.25V14.8582C16.9561 14.3587 16 12.5968 16 10.5C16 8.01472 17.3431 6 19 6C20.6569 6 22 8.01472 22 10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseTree);
export default __webpack_public_path__ + "static/media/house-tree.1e010219dd08499adeeb2cea809af0d6.svg";
export { ForwardRef as ReactComponent };